import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=5d3e1923&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"
import style0 from "./Lists.vue?vue&type=style&index=0&id=5d3e1923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e1923",
  null
  
)

export default component.exports